import colors from "../../base/colors";

const { transparent, primary } = colors;

const inputBase = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      "& .MuiOutlinedInput-notchedOutline, &:hover": {
        borderColor: primary.main,
      },
    },
  },
};
export default inputBase;
